import { lazy, Suspense } from "react";

import HdLoader from "@hd/ui-kit/hd-loader/HdLoader";
import HdModal from "@hd/ui-kit/hd-modal/HdModal";
import { useDooryCustomKnowledgeModalStore } from "./doory-custom-knowledge-modal.store";

const DooryCustomKnowledgeModalContent = lazy(() => import("./DooryCustomKnowledgeModalContent"));

function DooryCustomKnowledgeModal() {
  const isOpen = useDooryCustomKnowledgeModalStore((state) => state.isOpen);
  const closeModal = useDooryCustomKnowledgeModalStore((state) => state.close);

  return (
    <HdModal
      backdrop={true}
      isOpen={isOpen}
      closeOnEsc={true}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          closeModal();
        }
      }}
      zIndex={50}
      // closeOnClickOutside={false}
      className="p-2 bg-white w-[600px]  flex flex-col"
    >
      <Suspense fallback={<HdLoader></HdLoader>}>
        <DooryCustomKnowledgeModalContent></DooryCustomKnowledgeModalContent>
      </Suspense>
    </HdModal>
  );
}

export default DooryCustomKnowledgeModal;
